import React, { useState } from 'react';
import { filter } from 'lodash';

import app from 'components/app';
import Page from 'components/Page';
import PageSpacer from 'components/Page/PageSpacer';
import Section from 'components/Page/Section';
import Wrapper from 'components/Page/Wrapper';
import H1 from 'components/typo/Heading/H1';
import P from 'components/typo/P';
import ContentHalves from 'components/ContentHalves';
import PremadeContentWhiteBox from 'components/ContentWhiteBox/PremadeContentWhiteBox';
import { useTranslation } from 'lib/i18n';

import illu from './images/illustration_ink-with-feather.svg';
import ARTICLES, { Article } from './articles';
import PressImage from './PressImage';
import PressCheckboxes from './PressCheckboxes';
import {
  TYPE_INTERNET,
  TYPE_PARTNERS,
  TYPE_PRINT,
  TYPE_BLOG,
} from './constants';
import { ArticleType } from './types';

const PressIndex: React.FC = () => {
  const { t } = useTranslation('pages');

  const [state, setState] = useState({
    [TYPE_INTERNET]: true,
    [TYPE_PARTNERS]: true,
    [TYPE_PRINT]: true,
    [TYPE_BLOG]: true,
  });

  const onChange = (key: ArticleType): void => {
    setState({
      ...state,
      [key]: !state[key],
    });
  };

  const get_articles = (): { left: Article[]; right: Article[] } | null => {
    const filtered = filter(ARTICLES, article => state[article.type]);
    if (filtered.length === 0) return null;
    return {
      left: filtered.filter((value, i) => i % 2 === 0),
      right: filtered.filter((value, i) => i % 2 === 1),
    };
  };

  const renderArticles = (): JSX.Element => {
    const articles = get_articles();
    if (!articles) {
      return <P>{t('press.no_articles')}</P>;
    }
    return (
      <ContentHalves>
        {['left', 'right'].map(key => (
          <div key={key}>
            {articles[key as 'left' | 'right'].map(article => (
              <PremadeContentWhiteBox
                key={article.id}
                text={article.text}
                link={article.link}
                video={article.video}
                youtube={article.youtube}
                moreText={
                  article.video || article.youtube
                    ? t('press.see_video')
                    : t('press.see_article')
                }
                bottomText={article.journal}
                bottomLogo={article.logo}
              />
            ))}
          </div>
        ))}
      </ContentHalves>
    );
  };

  return (
    <Page title={t('press.title')} footer noPadding>
      <>
        <Section sidbColor>
          <Wrapper>
            <>
              <H1>{t('press.title')}</H1>
              <PressCheckboxes state={state} onChange={onChange} t={t} />
              <PressImage src={illu} />
            </>
          </Wrapper>
        </Section>
        <Section gray topWave>
          <Wrapper>
            <PageSpacer>{renderArticles()}</PageSpacer>
          </Wrapper>
        </Section>
      </>
    </Page>
  );
};

export default app(PressIndex);
